import React from 'react';
import { AgendaItem } from './AgendaItem/AgendaItem';
import { st, classes } from './DaySection.st.css';
import { Divider, Text } from 'wix-ui-tpa/cssVars';
import {
  DaySectionViewModel,
  LayoutTypes,
} from '../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaViewModel';
import { useEnvironment } from '@wix/yoshi-flow-editor';

export const DaySection: React.FC<DaySectionViewModel> = ({
  date,
  splittedDate,
  agendaItems,
  layoutType = LayoutTypes.LIST,
}) => {
  const { isMobile } = useEnvironment();

  const renderDate = () => {
    if (isMobile) {
      return <Text className={classes.date}>{date}</Text>;
    }

    return (
      <>
        <Text className={classes.splittedDate}>{splittedDate.date}</Text>
        <Text className={classes.splittedDay}>{splittedDate.day}</Text>
      </>
    );
  };

  return (
    <section className={st(classes.root, { layoutType, isMobile })}>
      <div
        className={st(classes.dateContainer, classes.listItem)}
        role="presentation"
      >
        {renderDate()}
      </div>
      <ul className={classes.slotList}>
        {agendaItems.map((agendaItemViewModel, index) => (
          <li
            className={classes.slotContainer}
            key={agendaItemViewModel.slotId}
          >
            <AgendaItem
              layoutType={layoutType}
              agendaItemViewModel={agendaItemViewModel}
            />
            <Divider className={classes.agendaItemDivider} />
          </li>
        ))}
      </ul>
    </section>
  );
};
